import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import { getAllLanguagesEndpoint } from "~/modules/country/api/language/languageApiEndpoints.ts";
import type { Language } from "~/modules/country/api/language/lanugageTypes.ts";

export const getAllLanguages = (): AxiosApiResponsePromise<Language[]> => axiosApi.get(getAllLanguagesEndpoint);
